module.exports = __webpack_public_path__ + "static/media/file-search.c074cc4d.svg";